import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseCombobox } from '../../controls/BaseCombobox';
import { LeftRightOption } from '../../infrastructure/AppConstants';
import orderService from '../OrderService';
export class StepComboBoxGroup extends Component {
    constructor(props) {
        super(props);

        let leftValue = "-1";
        let rightValue = "-1";
        let value = this.props.value;
        if (value) {
            var vals = value.split(',');
            if (vals.length == 2) {
                leftValue = vals[0];
                rightValue = vals[1];
            }
        }

        if (leftValue == -1 && this.props.leftItems && this.props.leftItems.length >0) {
            leftValue = this.props.leftItems[0].id;
        }
        if (rightValue == -1 && this.props.rightItems && this.props.rightItems.length > 0) {
            rightValue = this.props.rightItems[0].id;
        }

        this.state = { leftValue: leftValue, rightValue: rightValue };
        
        this.handleLeftValueChange = this.handleLeftValueChange.bind(this);
        this.handleRightValueChange = this.handleRightValueChange.bind(this);
       // console.log(leftValue);
    }

    componentDidMount() {
       
        this.handleLeftValueChange({ target: { value: this.state.leftValue } });
        this.handleRightValueChange({ target: { value: this.state.rightValue } });
    }

    handleLeftValueChange(e) {
        var handle = this.props.onSelectValueChanged;
        if (handle) {
            this.setState({ leftValue: e.target.value }, () => {
                var e = this.state.leftValue + ',' + this.state.rightValue;
                handle(e);
            });

        }
    }

    handleRightValueChange(e) {
        var handle = this.props.onSelectValueChanged;
        if (handle) {
            this.setState({ rightValue: e.target.value }, () => {
                var e = this.state.leftValue + ',' + this.state.rightValue;
                handle(e);
            });
        }
    }

    render() {
      //  console.log(this.props);
        const title = this.props.title;
        let leftItems = this.props.leftItems||[];
        let rightItems = this.props.rightItems||[];
        //let items = this.props.items;
        //if (!items) {
        //    items = [];
        //}
        var isLeft = this.props.leftRightOption == LeftRightOption.LeftEarOption;
        var isRight = this.props.leftRightOption == LeftRightOption.RightEarOption;
        var disabledStyle = " bg-gray-200";
        let leftObsolete = false;
        let rightObsolete = false;
        if (title === 'OnlyForRICSeries') {
            var hasRic = orderService.getHasRic();
            if (!hasRic.leftHasRic) {
                leftObsolete = true;
            }
            if (!hasRic.rightHasRic) {
                rightObsolete = true;
            }
        } 
        return (
            <div className="mx-0 mb-4">
                <div className="border-b-2 border-blue-900 text-blue-800 font-bold" ><h2><FormattedMessage id={title} />
                    {this.props.note ? <span className="text-red-500"><FormattedMessage id="DefaultNote" /></span>:""}
                </h2></div>
                <div className="flex flex-row mt-2">
                    <div className="bg-blue-200 w-6 flex flex-col text-center mr-2">
                        <label><FormattedMessage id="Left" /></label>
                        <div className="self-center mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-blue-500 sm:mx-0 sm:h-5 sm:w-5">
                            <label className="text-white">L</label>
                        </div>
                    </div>
                    <div className="flex-grow place-self-center border-t border-gray-50">
                        <BaseCombobox disabled={leftObsolete === true || isRight} classnames={"bg-right w-full py-0 border-gray-200 focus:ring-indigo-500 focus:border-indigo-500 rounded-sm text-xs " + ((leftObsolete === true || isRight) ? disabledStyle : "")} onChange={this.handleLeftValueChange} value={this.state.leftValue} >
                            {/*<FormattedMessage id="CompanyDefault" >*/}
                            {/*    {text => <option value="-1">{text}</option>}*/}
                            {/*</FormattedMessage>*/}
                            {leftItems.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                        </BaseCombobox>
                    </div>
                </div>
                <div className="flex flex-row">
                    <div className="bg-red-200 w-6 flex flex-col text-center mr-2">
                        <label><FormattedMessage id="Right" /></label>
                        <div className="self-center mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-blue-500 sm:mx-0 sm:h-5 sm:w-5">
                            <label className="text-white">R</label>
                        </div>
                    </div>
                    <div className="flex-grow place-self-center  border-b border-gray-50">
                        <BaseCombobox disabled={rightObsolete === true || isLeft} classnames={"bg-right w-full py-0  border-gray-200 focus:ring-indigo-500 focus:border-indigo-500 rounded-sm text-xs " + ((rightObsolete === true ||isLeft) ? disabledStyle : "")} onChange={this.handleRightValueChange} value={this.state.rightValue}>
                            {/*<FormattedMessage id="CompanyDefault" >*/}
                            {/*    {text => <option value="-1">{text}</option>}*/}
                            {/*</FormattedMessage>*/}
                            {rightItems.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                        </BaseCombobox>
                    </div>
                </div>
            </div>

        );

    }

}
